import { IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import { PullRefresh } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { ROUTE_RECEIVERS_TRAFFIC } from '@apps-radionet-portal/config/private-routes'

export const ReceiverTrafficPage: React.FC = () => {
  const { companyId, receiverId } = useParams<{ companyId: string; receiverId: string }>()

  return (
    <IonPage>
      <Header>
        <Navbar showBack transparent icons={[]} />
        <Breadcrumbs route={ROUTE_RECEIVERS_TRAFFIC} />
        <div className='flex items-center justify-between'>
          <PageTitle>Receiver Traffic</PageTitle>
          {/* <Authorization roles={AUTH_CLAIMS.managementAdmin.roles} scopes={AUTH_CLAIMS.managementAdmin.scopes}>
            <div className='relative flex items-center justify-end gap-[5px]'>
              <ManagementOrderDetailsOptions
                loading={loading}
                updating={updating}
                status={status}
                orderId={orderId}
                isUpdatingCallback={(value) => setChildIsUpdating(value)}
              />
            </div>
          </Authorization> */}
        </div>
      </Header>
      <LayoutContainer>
        <PullRefresh loading={false} callback={() => {}} />
        <LayoutPadding>
          <div className=''>
            <div />
          </div>
        </LayoutPadding>
      </LayoutContainer>
    </IonPage>
  )
}
